let readMore = {
    init: () => {
        const readMores = document.querySelectorAll('.js-read-more');

        const openReadMore = (readMore) => {
            return () => {
                readMore.classList.add('active');
                document.body.classList.add('modal-active');
            }
        }

        const closeReadMore = (readMore) => {
            return () => {
                readMore.classList.remove('active');
                setTimeout(() => {
                    document.body.classList.remove('modal-active');
                }, 300);
            }
        }

        const preventClose = () => {
            return (e) => {
                e.stopPropagation();
            }
        }

        if(readMores) {
            readMores.forEach((readMore) => {
                const content = readMore.querySelector('.js-read-more-content');
                if(content) {
                    content.addEventListener('click', closeReadMore(readMore));
                    content.querySelector('.content').addEventListener('click', preventClose());
                }
                
                const readMoreOpen = readMore.querySelector('.js-read-more-open');
                if(readMoreOpen)
                    readMoreOpen.addEventListener('click', openReadMore(readMore));

                const closeBtns = readMore.querySelectorAll('.js-read-more-close');
                if(closeBtns)
                    closeBtns.forEach(btn => btn.addEventListener('click', closeReadMore(readMore)));
            });
        }
    }
}

export default readMore;